import { ApiProperty } from '@nestjs/swagger';
import { IsBoolean, IsInt, IsNotEmpty, IsOptional, IsUUID, Max, Min } from 'class-validator';

export class CreateEmpresaMonedaDto {
  @ApiProperty({ example: 'uuid-moneda', description: 'ID de la moneda' })
  @IsNotEmpty()
  @IsUUID()
  moneda_id: string;

  @ApiProperty({ example: false, description: 'Es la moneda principal de la empresa', required: false })
  @IsOptional()
  @IsBoolean()
  es_principal?: boolean;

  @ApiProperty({ example: 2, description: 'Decimales a visualizar en la UI', required: false })
  @IsOptional()
  @IsInt()
  @Min(0)
  @Max(6)
  decimales_visualizar?: number;

  @ApiProperty({ example: true, description: 'Estado activo', required: false })
  @IsOptional()
  @IsBoolean()
  active?: boolean;
}
